import { createAsyncThunk } from "@reduxjs/toolkit";
import { TOAST_VARIANT } from "@root/constants";
import { AdminAuthService } from "@root/services/admin/auth";
import { prepareErrorResponse } from "@root/services/http/response";
import { ADMIN_LOGIN_ACTION, DELETE_ADMIN_ACTION, GET_ADMIN_PROFILE_ACTION, MAKE_ADMIN_ACTION } from "@root/store/action-types/admin/auth";
import { getBaseUrl } from "@root/store/selectors/features";
import { showAlert } from "@root/store/slices/features";
import { LocalStorageService } from "@root/services/local-storage";
import { setAuthData } from "@root/store/slices/entities/auth";

const adminAuthService = new AdminAuthService();
const localStorageService = new LocalStorageService();

export const adminLogin: any = createAsyncThunk(
    ADMIN_LOGIN_ACTION,
    async (requestPayload: any, thunkAPI: any) => {
        const { onSuccess, onError, payload } = requestPayload;

        try {
            const baseUrl = getBaseUrl(thunkAPI.getState());
            const result = await adminAuthService.login(baseUrl, payload);
            const responseData = result?.data?.data;
            const token = responseData?.token;
            
            // Store token using localStorageService
            if (token) {
                await localStorageService.persist("authToken", token);
            }
            
            // Update auth state immediately so router can detect logged-in user
            const { token: _, ...userData } = responseData;
            if (responseData?.user && typeof responseData.user === "object") {
                const { user, ...otherFields } = responseData;
                thunkAPI.dispatch(setAuthData({ ...user, ...otherFields }));
            } else {
                thunkAPI.dispatch(setAuthData(userData));
            }
            
            if (onSuccess) {
                onSuccess(responseData);
            }
            return thunkAPI.fulfillWithValue(responseData);
        } catch ({ response }: any) {
            if (onError) {
                onError(response);
            }
            thunkAPI.dispatch(
                showAlert({
                    // @ts-ignore
                    message: response?.data?.error,
                    type: TOAST_VARIANT.ERROR,
                })
            );
            const customError = prepareErrorResponse(response)
            return thunkAPI.rejectWithValue(customError);
        }
    }
);

export const adminMakeAdmin: any = createAsyncThunk(
    MAKE_ADMIN_ACTION,
    async (requestPayload: any, thunkAPI: any) => {
        const { onSuccess, onError, payload } = requestPayload;

        try {
            const baseUrl = getBaseUrl(thunkAPI.getState());
            const result = await adminAuthService.makeAdmin(baseUrl, payload);
            if (onSuccess) {
                onSuccess(result?.data?.data);
            }
            return thunkAPI.fulfillWithValue(result?.data?.data);
        } catch ({ response }: any) {
            if (onError) {
                onError(response);
            }
            thunkAPI.dispatch(
                showAlert({
                    // @ts-ignore
                    message: response?.data?.error,
                    type: TOAST_VARIANT.ERROR,
                })
            );
            const customError = prepareErrorResponse(response)
            return thunkAPI.rejectWithValue(customError);
        }
    }
);
export const adminDeleteAdmin: any = createAsyncThunk(
    DELETE_ADMIN_ACTION,
    async (requestPayload: any, thunkAPI: any) => {
        const { onSuccess, onError, adminId } = requestPayload;

        try {
            const baseUrl = getBaseUrl(thunkAPI.getState());
            const result = await adminAuthService.deleteAdmin(baseUrl, adminId);
            if (onSuccess) {
                onSuccess(result?.data?.data);
            }
            return thunkAPI.fulfillWithValue(result?.data?.data);
        } catch ({ response }: any) {
            if (onError) {
                onError(response);
            }
            thunkAPI.dispatch(
                showAlert({
                    // @ts-ignore
                    message: response?.data?.error,
                    type: TOAST_VARIANT.ERROR,
                })
            );
            const customError = prepareErrorResponse(response)
            return thunkAPI.rejectWithValue(customError);
        }
    }
);
export const adminGetProfile: any = createAsyncThunk(
    GET_ADMIN_PROFILE_ACTION,
    async (requestPayload: any, thunkAPI: any) => {
        const { onSuccess, onError } = requestPayload;

        try {
            const baseUrl = getBaseUrl(thunkAPI.getState());
            const result = await adminAuthService.getProfile(baseUrl);
            if (onSuccess) {
                onSuccess(result?.data?.data);
            }
            return thunkAPI.fulfillWithValue(result?.data?.data);
        } catch ({ response }: any) {
            if (onError) {
                onError(response);
            }
            thunkAPI.dispatch(
                showAlert({
                    // @ts-ignore
                    message: response?.data?.error,
                    type: TOAST_VARIANT.ERROR,
                })
            );
            const customError = prepareErrorResponse(response)
            return thunkAPI.rejectWithValue(customError);
        }
    }
);